import React, { FC } from "react";

export const CopyIcon: FC<any> = ({ sizes, onClick }) => {

    return (
        <svg 
            onClick={onClick}
            width={sizes || "32"}
            height={sizes || "32"}
            viewBox="0 0 32 32"
            style={{ cursor: "pointer" }}
            className="hidden">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.3359 20.227V14.7275C15.3359 14.3275 
            15.0011 14.0037 14.5893 14.0037C9.09958 14.0037 4.05905 17.0827 1.60286 21.7231C1.52945 
            21.1817 1.49337 20.6343 1.49337 20.0857C1.49337 16.69 2.85584 13.4986 5.33069 
            11.0938C7.80554 8.69145 11.0904 7.36822 14.5843 7.36822H14.5893C14.7871 7.36822 
            14.9763 7.2933 15.1169 7.15795C15.2575 7.02019 15.3359 6.83651 15.3359 6.64437L15.2525 
            1.43728L27.3941 10.7808L15.3359 20.227ZM28.3248 9.72585L16.1844 
            0.304981C15.7477 -0.0345859 15.1641 -0.0974159 14.659 0.137018C14.155 0.371452 
            13.8427 0.856029 13.8427 1.39861V5.93503C6.1432 6.31327 0.000244141 12.5161 
            0.000244141 20.0857C0.000244141 21.5321 0.229189 22.9678 0.680859 24.3478C0.779156 
            24.6487 1.06658 24.8529 1.39134 24.8529H1.39382C1.71982 24.8529 2.00725 24.6462 
            2.1043 24.3441C3.71314 19.3413 8.4762 15.7776 13.8427 15.4731V20.227C13.8427 
            20.7696 14.155 21.253 14.659 21.4886C15.1617 21.7243 15.7465 21.659 16.1832 
            21.3207L28.3248 11.9131C28.6694 11.6448 28.8673 11.246 28.8673 10.8183C28.8673 
            10.3905 28.6694 9.99171 28.3248 9.72585Z" fill="#8E9193"></path>
        </svg>
    )
}import React, { FC } from "react";

export const CopyIcon: FC<any> = ({ sizes, onClick }) => {

    return (
        <svg 
            onClick={onClick}
            width={sizes || "32"}
            height={sizes || "32"}
            viewBox="0 0 32 32"
            style={{ cursor: "pointer" }}
            className="hidden">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.3359 20.227V14.7275C15.3359 14.3275 
            15.0011 14.0037 14.5893 14.0037C9.09958 14.0037 4.05905 17.0827 1.60286 21.7231C1.52945 
            21.1817 1.49337 20.6343 1.49337 20.0857C1.49337 16.69 2.85584 13.4986 5.33069 
            11.0938C7.80554 8.69145 11.0904 7.36822 14.5843 7.36822H14.5893C14.7871 7.36822 
            14.9763 7.2933 15.1169 7.15795C15.2575 7.02019 15.3359 6.83651 15.3359 6.64437L15.2525 
            1.43728L27.3941 10.7808L15.3359 20.227ZM28.3248 9.72585L16.1844 
            0.304981C15.7477 -0.0345859 15.1641 -0.0974159 14.659 0.137018C14.155 0.371452 
            13.8427 0.856029 13.8427 1.39861V5.93503C6.1432 6.31327 0.000244141 12.5161 
            0.000244141 20.0857C0.000244141 21.5321 0.229189 22.9678 0.680859 24.3478C0.779156 
            24.6487 1.06658 24.8529 1.39134 24.8529H1.39382C1.71982 24.8529 2.00725 24.6462 
            2.1043 24.3441C3.71314 19.3413 8.4762 15.7776 13.8427 15.4731V20.227C13.8427 
            20.7696 14.155 21.253 14.659 21.4886C15.1617 21.7243 15.7465 21.659 16.1832 
            21.3207L28.3248 11.9131C28.6694 11.6448 28.8673 11.246 28.8673 10.8183C28.8673 
            10.3905 28.6694 9.99171 28.3248 9.72585Z" fill="#8E9193"></path>
        </svg>
    )
}